import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Portfolio from './pages/Portfolio';
import QuoteGenPrivacyPolicy from './pages/QuoteGenPrivacyPolicy';
import QuoteGenSupport from './pages/QuoteGenSupport';
import ShelflinePrivacyPolicy from './pages/ShelflinePrivacyPolicy';
import ShelflineSupport from './pages/ShelflineSupport';
import ShelflineTerms from './pages/ShelflineTerms';
import BunkerPrivacyPolicy from './pages/BunkerPrivacyPolicy';
import BunkerSupport from './pages/BunkerSupport';
import BunkerTerms from './pages/BunkerTerms';
import FathomPrivacyPolicy from './pages/FathomPrivacyPolicy';
import FathomSupport from './pages/FathomSupport';
import FathomTerms from './pages/FathomTerms';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/quotegen/privacy-policy" element={<QuoteGenPrivacyPolicy />} />
        <Route path="/quotegen/support" element={<QuoteGenSupport />} />
        <Route path="/shelfline/privacy-policy" element={<ShelflinePrivacyPolicy />} />
        <Route path="/shelfline/support" element={<ShelflineSupport />} />
        <Route path="/shelfline/terms" element={<ShelflineTerms />} />
        <Route path="/bunker/privacy-policy" element={<BunkerPrivacyPolicy />} />
        <Route path="/bunker/support" element={<BunkerSupport />} />
        <Route path="/bunker/terms" element={<BunkerTerms />} />
        <Route path="/fathom/privacy-policy" element={<FathomPrivacyPolicy />} />
        <Route path="/fathom/support" element={<FathomSupport />} />
        <Route path="/fathom/terms" element={<FathomTerms />} />
      </Routes>
    </Router>
  );
}

export default App;
